import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonContent, IonHeader } from '@ionic/angular/standalone';
import C2U from '@chemist2u/types-client';
import { SearchInputComponent } from 'src/app/components/primitives/search-input/search-input.component';
import { CategoryCardComponent } from 'src/app/components/elements/category-card/category-card.component';
import { StateService } from 'src/app/services/state.service';
import { CategoryGridComponent } from 'src/app/components/scaffolds/category-grid/category-grid.component';
import { Category, SubCategory } from '@chemist2u/types-client/C2U/ParseObjects';
import { ItemSearchComponent, TSearchTermSelected } from 'src/app/components/elements/item-search/item-search.component';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { ProductScrollerComponent } from "../../components/scaffolds/product-scroller/product-scroller.component";
import { AmplitudeService } from 'src/app/services/amplitude.service';

@Component({
    selector: 'app-browse',
    templateUrl: './browse.page.html',
    styleUrls: ['./browse.page.scss'],
    imports: [CommonModule, IonHeader, SearchInputComponent, IonContent, CategoryGridComponent, CategoryCardComponent, ItemSearchComponent, ProductScrollerComponent]
})
export class BrowsePage implements OnInit {
  //Services
  private $state = inject(StateService);
  private router = inject(Router);
  private $amplitude = inject(AmplitudeService);

  public state = signal<"top" | "search" | "grid">("top");
  public products: C2U.Elastic.TElasticItemClient[] = [];
  public searchText = signal<string>('');

  public categories = signal<Category[]>([]);
  public subCategories = signal<SubCategory[]>([]);

  // TODO: This really needs to be implemented because it currently isn't no actual search is being recorded
  public recentSearchTerms: string[] = [];

  public session = toSignal(this.$state.bSession);

  async ngOnInit() {
    this.$amplitude.track('NAVIGATE_BROWSE');
    this.categories.set(this.$state.bCategories.getValue());
    this.subCategories.set(this.$state.bSubCategories.getValue());

    this.$state.bCategories.subscribe((categories) => {
      this.categories.set(categories);
    });

    this.$state.bSubCategories.subscribe((subCategories) => {
      this.subCategories.set(subCategories);
    });

  }

  backToCategories() {
    this.state.set('top');
  }

  searchCleared() {
    this.state.set('top');
    this.$amplitude.track('ITEM_SEARCH_CLEARED');
  }

  searchChange(term: string) {
    this.searchText.set(term);
    this.state.set('grid');
    this.$amplitude.track('ITEM_SEARCH_CHANGE');
  }

  searchFocus() {
    this.state.set('search');
    this.$amplitude.track('ITEM_SEARCH_FOCUS_IN');
  }

  searchFocusOut() {
    if (this.searchText().length > 0) {
      this.state.set('grid');
      this.$amplitude.track('ITEM_SEARCH_FOCUS_OUT');
    }
  }

  selectedSearchElement(term: TSearchTermSelected) {
    this.searchChange(term.searchTerm);
    this.$amplitude.track('ITEM_SEARCH_TERM_SELECTED');
  }

  goToCategory(id: string, type: 'category' | 'subcategory') {
    this.router.navigate([`/tabs/browse/medicine-results/${id}`], {
      queryParams: { type }
    });
    if (type == 'category') {
      this.$amplitude.track('NAVIGATE_CATEGORY', { categoryId: id });
    } else {
      this.$amplitude.track('NAVIGATE_SUBCATEGORY', { subcategoryId: id });
    }
  }

}